/**
 * Extract decimal places for fiat currency
 */
export function extractFiatDecimalPlaces(fiatCode?: string): number {
  if (!fiatCode) return 2

  // Special cases for currencies with different decimal places
  const specialCases: Record<string, number> = {
    KWD: 3, // Kuwait Dinar
    BHD: 3, // Bahrain Dinar
    OMR: 3, // Omani Rial
    JOD: 3, // Jordanian Dinar
    JPY: 0, // Japanese Yen
    KRW: 0, // Korean Won
    VND: 0, // Vietnamese Dong
    ISK: 0, // Icelandic Krona
    CLP: 0, // Chilean Peso
    PYG: 0, // Paraguayan Guarani
    UGX: 0, // Ugandan Shilling
    // Add more as needed
  }

  return specialCases[fiatCode] ?? 2
}
